import { Component } from "react"
import Birthday from "./Birthday"
import Email from "./Email"
import MisskeyId from "./MisskeyId"
import HomePage from "./HomePage"
import TwitterId from "./TwitterId"
import DiscordUserName from "./DiscordUserName"
import InstagramId from "./InstagramId"
import GitHubId from "./GitHubId"
import HuggingFaceId from "./HuggingFaceId"
import Password from "./Password"
import BackgroundImage from "./BackgroundImage"
import ProfileImage from "./ProfileImage"
import SelfIntroduction from "./SelfIntroduction"
import Sex from "./Sex"
import DisplayId from "./DisplayId"
import UserName from "./UserName"
import UserNameKana from "./UserNameKana"
import UserId from "./UserId"

type Props = {
    userId:UserId,email:Email,misskeyId:MisskeyId,password:Password,displayId:DisplayId,userName:UserName,userNameKana:UserNameKana,homePage:HomePage,twitterId:TwitterId,discordUserName:DiscordUserName,instagramId:InstagramId,gitHubId:GitHubId,huggingFaceId:HuggingFaceId,sex:Sex,birthday:Birthday,selfIntroduction:SelfIntroduction,
    backgroundImage:BackgroundImage,profileImage:ProfileImage
}
class UserInfo extends Component {
    private _userId: UserId
    private _email: Email
    private _misskeyId: MisskeyId
    private _password: Password
    private _displayId: DisplayId
    private _userName: UserName
    private _userNameKana: UserNameKana
    private _homePage: HomePage
    private _twitterId: TwitterId
    private _discordUserName: DiscordUserName
    private _instagramId: InstagramId
    private _gitHubId: GitHubId
    private _huggingFaceId: HuggingFaceId
    private _sex: Sex
    private _birthday: Birthday
    private _selfIntroduction: SelfIntroduction
    private _backgroundImage: BackgroundImage
    private _profileImage: ProfileImage

    constructor(props:Props){
        super(props)
        this._userId = props.userId
        this._email = props.email
        this._misskeyId = props.misskeyId
        this._password = props.password
        this._displayId = props.displayId
        this._userName = props.userName
        this._userNameKana = props.userNameKana
        this._homePage = props.homePage
        this._twitterId = props.twitterId
        this._discordUserName = props.discordUserName
        this._instagramId = props.instagramId
        this._gitHubId = props.gitHubId
        this._huggingFaceId = props.huggingFaceId
        this._sex = props.sex
        this._birthday = props.birthday
        this._selfIntroduction = props.selfIntroduction
        this._backgroundImage = props.backgroundImage
        this._profileImage = props.profileImage
    }

    public get values() {
        return {
            userId:this.userId.props,
            email:this.email.props,
            misskeyId:this.misskeyId.props,
            password:this.password.props,
            displayId:this.displayId.props,
            userName:this.userName.props,
            userNameKana:this.userNameKana.props,
            homePage:this.homePage.props,
            twitterId:this.twitterId.props,
            discordUserName:this.discordUserName.props,
            instagramId:this.instagramId.props,
            gitHubId:this.gitHubId.props,
            huggingFaceId:this.huggingFaceId.props,
            sex:this.sex.props,
            birthday:this.birthday.props,
            selfIntroduction:this.selfIntroduction.props,
            backgroundImage:this.backgroundImage.props,
            profileImage:this.profileImage.props
        }
    }

    validate(callbackDialog:any): boolean {
        return this.email.validate(callbackDialog,false) && this.misskeyId.validate(callbackDialog,false) && this.displayId.validate(callbackDialog,false)
            && this.userName.validate(callbackDialog,false) && this.userNameKana.validate(callbackDialog,false) && this.homePage.validate(callbackDialog,false)
            && this.twitterId.validate(callbackDialog,false) && this.discordUserName.validate(callbackDialog,false) && this.instagramId.validate(callbackDialog,false)
            && this.gitHubId.validate(callbackDialog,false) && this.huggingFaceId.validate(callbackDialog,false)
            // && this.sex.validate(callbackDialog,false) && this.birthday.validate(callbackDialog,false)
            && this.selfIntroduction.validate(callbackDialog,false) && this.backgroundImage.validate(callbackDialog,false) 
            && this.profileImage.validate(callbackDialog,false)
    }

    public get userId(): UserId {
        return this._userId
    }
    public get email(): Email {
        return this._email
    }
    public get misskeyId(): MisskeyId {
        return this._misskeyId
    }
    public get password(): Password {
        return this._password
    }
    public get displayId(): DisplayId {
        return this._displayId
    }
    public get userName(): UserName {
        return this._userName
    }
    public get userNameKana(): UserNameKana {
        return this._userNameKana
    }
    public get homePage(): HomePage {
        return this._homePage
    }
    public get twitterId(): TwitterId {
        return this._twitterId
    }
    public get discordUserName(): DiscordUserName {
        return this._discordUserName
    }
    public get instagramId(): InstagramId {
        return this._instagramId
    }
    public get gitHubId(): GitHubId {
        return this._gitHubId
    }
    public get huggingFaceId(): HuggingFaceId {
        return this._huggingFaceId
    }
    public get sex(): Sex {
        return this._sex
    }
    public get birthday(): Birthday {
        return this._birthday
    }
    public get selfIntroduction(): SelfIntroduction {
        return this._selfIntroduction
    }
    public get backgroundImage(): BackgroundImage {
        return this._backgroundImage
    }
    public get profileImage(): ProfileImage {
        return this._profileImage
    }
}

export default UserInfo;